import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '~/app/core/components/confirm-dialog/confirm-dialog.component';
import { UxService, ValidationService } from '~/app/core/services';
import { DivisionListBaseComponent } from '~/app/open-age/directory/components/division-list-base.component';
import { Division } from '~/app/open-age/directory/models';
import { DivisionService } from '~/app/open-age/directory/services';

@Component({
  selector: 'directory-division-list',
  templateUrl: './division-list.component.html',
  styleUrls: ['./division-list.component.css']
})
export class DivisionListComponent extends DivisionListBaseComponent {

  @Input()
  view: 'table' | 'list' | 'grid' = 'table';
  dialogRef: any;

  constructor(
    public validationService: ValidationService,
    api: DivisionService,
    private uxService: UxService
  ) {
    super(api, uxService);
  }

  edit(department: Division, isEdit: boolean) {
    if (isEdit) {
      department.isEdit = true;
    } else {
      department.isEdit = false;
    }
  }

  save(item) {
    item.isEdit = false;
    this.update(item);
  }
  openDialog(item): void {
    this.uxService.onConfirm({
      message: 'Are you sure you want to delete?'
    }).subscribe(() => {
      this.remove(item);
      this.uxService.showInfo('Deleted');
    });
  }
}
